<template>
	<div>
		<button class="btn dealers_btn" @click="deleteDriver"> {{$t('text.actionButtons.delete')}} </button>
		<button class="btn dealers_btn mr-3" @click="editDriver">{{$t('text.actionButtons.edit')}}</button>
		<i
			class="fa-li fa fa-ellipsis-v dropbtn ml-2"
			@click="dropdownOption()"
		></i>
	</div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
	data() {
		return {
			data: {},
		};
	},
	mounted() {
		window.onclick = (event) => {
			if (!event.target.matches(".dropbtn")) {
				var dropdowns = document.getElementsByClassName("dropdown-content");
				var i;
				for (i = 0; i < dropdowns.length; i++) {
					var openDropdown = dropdowns[i];
					if (openDropdown.classList.contains("show")) {
						openDropdown.classList.remove("show");
					}
				}
			}
		};
	},
	methods: {
		editDriver() {
			this.$eventHub.$emit("editDriver", this.data);
			// let data = {
			//     id: this.data.id
			// };
			// this.axios
			// .post(
			//     `${configObject.apiBaseUrl}/Drivers/Delete`,
			//     data,
			//     configObject.authConfig()
			// )
			// .then(() => {
			//     this.$toast.open({
			//         message: this.$t('text.drivers.successfullyRemoved'),
			//         type: "success",
			//         duration: 3000
			//     });
			//     this.$eventHub.$emit("fetchDrivers");
			// })
			// .catch(error => {

			// });
		},
		deleteDriver() {
			const deleteConfirm = confirm(
				"Are you sure you want to delete this driver"
			);

			if (deleteConfirm) {
				// let data = {
				//     id: this.data.id
				// };
				this.axios
					.delete(
						`${configObject.apiBaseUrl}/Drivers/Delete/${this.data.id}`,
						configObject.authConfig()
					)
					.then(() => {
						this.$toast.open({
							message: this.$t("text.drivers.successfullyRemoved"),
							type: "success",
							duration: 3000,
						});
						this.$eventHub.$emit("fetchDrivers");
					})
					.catch((error) => {});
			}
		},
		dropdownOption() {
			this.$eventHub.$emit("showExtraDriversOptions", this.data, this);
		},
	},
};
</script>
